const hasPermissions = (roles: string[], loadedPermissions: boolean, permissions?: any) => {
    return (
        loadedPermissions &&
        permissions &&
        Array.isArray(permissions) &&
        roles.every((role) => permissions.includes(role))
    );
};
export { hasPermissions };
